<button mat-fab extended (click)="openDialog()" aria-label="Report Intervention">
  <mat-icon>report</mat-icon>
  Report Intervention
</button>
